import './index.scss'

import React from 'react'
import ReactDOM from 'react-dom'
import PageHome from './page-home/'

ReactDOM.render(<PageHome />, document.getElementById('root'))
